import PropTypes from 'prop-types';

export const CapOverallStatusPropTypes = {
  editable: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  jobId: PropTypes.number.isRequired,
  setOverallCapStatusValue: PropTypes.func.isRequired
};

export const CapOverallStatusDefaultPropTypes = {
  editable: false,
  value: null,
};
